<div [formGroup]="formGroup">
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
    <!-- UID field for edit mode only (disabled) -->
    <div *ngIf="mode === 'edit'">
      <label for="id" class="font-medium">ID</label>
      <input
        id="id"
        pInputText
        formControlName="uid"
        class="w-full p-2 mt-2 border-4 border-gray-200 rounded-xl focus:border-blue-500 appearance-none outline-none"
      />
    </div>

    <div>
      <label for="plant" class="font-medium"
        >Usine <span class="text-red-500">*</span></label
      >
      <p-select
        [ind4RoleDisabled]="'SED_PLUS_SUPER_USER'"
        formControlName="plant"
        [options]="(plantOptions$ | async) || []"
        optionLabel="label"
        optionValue="value"
        placeholder="Sélectionnez une usine"
        appendTo="body"
        [panelStyle]="{ width: '100%' }"
        class="w-full text-base mt-2 border-4 rounded-xl focus:border-blue-500 appearance-none outline-none"
        [ngClass]="{
          'border-red-500': getFieldError('plant'),
          'border-gray-200': !getFieldError('plant'),
        }"
      ></p-select>
      <small
        *ngIf="getFieldError('plant')"
        class="text-red-500 text-xs mt-1 block"
        >{{ getFieldError("plant") }}</small
      >
      <small *ngIf="plantLocked" class="text-orange-600 text-xs mt-1 block"
        >L'usine ne peut pas être modifiée tant que des formules de gain sont
        définies (étape Gains).</small
      >
    </div>

    <div>
      <label for="plannerGroup" class="font-medium"
        >Groupe de gestion <span class="text-red-500">*</span></label
      >
      <p-select
        [ind4RoleDisabled]="'SED_PLUS_SUPER_USER'"
        formControlName="plannerGroup"
        [options]="(plannerGroupOptions$ | async) || []"
        optionLabel="label"
        optionValue="value"
        placeholder="Sélectionnez un groupe de gestion"
        appendTo="body"
        [panelStyle]="{ width: '100%' }"
        class="w-full text-base mt-2 border-4 rounded-xl appearance-none outline-none"
        [ngClass]="{
          'border-red-500': getFieldError('plannerGroup'),
          'border-gray-200': !getFieldError('plannerGroup'),
        }"
      ></p-select>
      <small
        *ngIf="getFieldError('plannerGroup')"
        class="text-red-500 text-xs mt-1 block"
        >{{ getFieldError("plannerGroup") }}</small
      >
    </div>

    <div>
      <label for="workCenter" class="font-medium"
        >Poste de travail <span class="text-red-500">*</span></label
      >
      <p-select
        [ind4RoleDisabled]="'SED_PLUS_REGULAR_USER'"
        formControlName="workCenter"
        [options]="(workCenterOptions$ | async) || []"
        optionLabel="label"
        optionValue="value"
        placeholder="Sélectionnez un poste de travail"
        appendTo="body"
        [panelStyle]="{ width: '100%' }"
        class="w-full text-base mt-2 border-4 rounded-xl appearance-none outline-none"
        [ngClass]="{
          'border-red-500': getFieldError('workCenter'),
          'border-gray-200': !getFieldError('workCenter'),
        }"
      ></p-select>
      <small
        *ngIf="getFieldError('workCenter')"
        class="text-red-500 text-xs mt-1 block"
        >{{ getFieldError("workCenter") }}</small
      >
    </div>

    <div>
      <label for="functionalLocation" class="font-medium"
        >Poste technique <span class="text-red-500">*</span></label
      >
      <p-select
        [ind4RoleDisabled]="'SED_PLUS_REGULAR_USER'"
        formControlName="functionalLocation"
        [options]="functionalLocationOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Sélectionnez un poste technique"
        [filter]="true"
        filterBy="label"
        filterPlaceholder="Rechercher un poste technique"
        [showClear]="true"
        appendTo="body"
        [panelStyle]="{ width: '100%' }"
        [virtualScroll]="true"
        [virtualScrollItemSize]="38"
        [virtualScrollOptions]="{ lazy: false, itemSize: 38 }"
        [loading]="loadingFunctionalLocations"
        class="w-full text-base mt-2 border-4 rounded-xl appearance-none outline-none"
        [ngClass]="{
          'border-red-500': getFieldError('functionalLocation'),
          'border-gray-200': !getFieldError('functionalLocation'),
        }"
      ></p-select>
      <small
        *ngIf="getFieldError('functionalLocation')"
        class="text-red-500 text-xs mt-1 block"
        >{{ getFieldError("functionalLocation") }}</small
      >
    </div>
  </div>

  <!-- Labels Section -->
  <div class="p-4 pt-0" *ngIf="formGroup.get('workCenter')?.value">
    <label class="font-medium">Étiquettes de sous-secteur</label>
    <p-multiselect
      [options]="availableLabels"
      [(ngModel)]="selectedLabelIds"
      (ngModelChange)="onLabelChange()"
      [ngModelOptions]="{ standalone: true }"
      optionLabel="label"
      optionValue="uid"
      placeholder="Sélectionnez des étiquettes"
      [showClear]="true"
      [filter]="true"
      filterPlaceholder="Rechercher une étiquette"
      appendTo="body"
      display="chip"
      [loading]="loadingLabels"
      class="w-full text-base mt-2"
    ></p-multiselect>
  </div>
</div>
